import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=619704fe&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619704fe')) {
      api.createRecord('619704fe', component.options)
    } else {
      api.reload('619704fe', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=619704fe&", function () {
      api.rerender('619704fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kvPBXCEXBZjc/JS/offershelp.vue"
export default component.exports